import Vue from 'vue'
import TurbolinksAdapter from 'vue-turbolinks'

import Integrator from './index.vue'

document.addEventListener('turbolinks:load', () => {
  const el = document.getElementById('questions-tools-integrator')
  if (el) {
    const props = JSON.parse(el.getAttribute('data'))
    new Vue({
      el,
      mixins: [TurbolinksAdapter],
      render: h => h(Integrator, {props})
    })
  }
})



// WEBPACK FOOTER //
// ./app/javascript/packs/questions/tools/integrator/index.js